import React, { PropsWithChildren } from 'react'
import './index.scss'
import { SearchResultPartyDetails } from '@Entities/party-details'
import clsx from 'clsx'
import Pluralize from 'pluralize'

interface SearchResultPartyDetailsCardProps {
    partyDetails: SearchResultPartyDetails
    onTitleClick(partyDetails: SearchResultPartyDetails): void
}

const SearchResultPartyDetailsCard = ({
    partyDetails,
    onTitleClick,
    children,
}: PropsWithChildren<SearchResultPartyDetailsCardProps>) => (
    <div className="search-by-item">
        <div className="search-by-item-head">
            <div
                className={clsx('info-container', !!partyDetails.worksCount && 'clickable')}
                onClick={() => !!partyDetails.worksCount && onTitleClick(partyDetails)}
            >
                <div className="name-block">
                    <span className="name bold">{partyDetails.name}:&nbsp;</span>
                    <span className="count bold blue-text">
                        {partyDetails.worksCount != null && Pluralize('title', partyDetails.worksCount, true)}
                    </span>
                </div>

                {partyDetails.hfaPublisherNumber && (
                    <div className="mlc-pub-number-block">
                        <span className="small-2">MLC Publisher Number:&nbsp;</span>
                        <span className="small-2 bold">{partyDetails.hfaPublisherNumber}</span>
                    </div>
                )}

                <div className="number-block ipi-block">
                    {partyDetails.ipiNumber && (
                        <>
                            <span className="name">IPI:&nbsp;</span>
                            <span className="name bold">{partyDetails.ipiNumber}</span>
                        </>
                    )}
                </div>
            </div>
            <div className="additional-data-container">{children}</div>
        </div>
    </div>
)

export default SearchResultPartyDetailsCard
